import { AuthApi } from 'api/AuthApi';

import { authApiClient } from './authApiClient';

export const authApi = new AuthApi(authApiClient);
